import React from 'react';
import './TakimSection.css';

const TakimSection = () => {
  return (
    <div className="takim-container">
      {/* Etkinlikler Başlığı */}
      <h2>Etkinlikler</h2>
      <p className="subtitle">Takım içi etkinlikler, organizasyonlar ve talepler</p>

      {/* Örnek Etkinlik Listesi */}
      <div className="etkinlik-list">
        <div className="etkinlik-item">
          <h4>Takım Yemeği</h4>
          <div className="etkinlik-date">15.04.2025 - 19:00</div>
          <div className="etkinlik-desc">Yaza Merhaba Yemeği</div>
        </div>
        <div className="etkinlik-item">
          <h4>Online Toplantı</h4>
          <div className="etkinlik-date">20.04.2025 - 10:00</div>
          <div className="etkinlik-desc">Proje Durum Değerlendirmesi</div>
        </div>
      </div>

      {/* Etkinlik Talep Et (Form) */}
      <div className="etkinlik-form-section">
        <h3>Etkinlik Talep Et</h3>
        <p>Yeni bir etkinlik talebi oluşturmak için bilgileri doldurun.</p>

        <form className="etkinlik-form">
          <div className="form-group">
            <label htmlFor="title">Etkinlik Başlığı</label>
            <input
              type="text"
              id="title"
              name="title"
              placeholder="Örn: Piknik Organizasyonu"
            />
          </div>

          <div className="form-group">
            <label htmlFor="date">Tarih</label>
            <input type="date" id="date" name="date" />
          </div>

          <div className="form-group">
            <label htmlFor="time">Saat</label>
            <input type="time" id="time" name="time" />
          </div>

          <div className="form-group" style={{ gridColumn: '1 / span 2' }}>
            <label htmlFor="desc">Açıklama</label>
            <textarea
              id="desc"
              name="desc"
              rows="3"
              placeholder="Etkinlik açıklaması..."
            ></textarea>
          </div>

          <button type="submit" className="btn-talep-et">
            Talep Gönder
          </button>
        </form>
      </div>
    </div>
  );
};

export default TakimSection;
